import {
  Typography,
} from '@mui/material';
import DataNotFoundIcon from '@mui/icons-material/SentimentDissatisfied';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './IconWithMessagePaper.scss';

/**
 * Paper card for display No lesson available.
 */
const defaultProps = {
  Icon: DataNotFoundIcon,
  message: '',
};
export default function IconWithMessagePaper(props) {
  const { Icon, message } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className='no-data-found-paper'>
      <Icon className='no-data-found-icon' />
      <Typography component='p' className='no-data-found-message'>
        {message}
      </Typography>
    </div>
  );
}
